<template>
    <!-- 获得商品记录 -->
    <div class="one_des">
        <div class="title flex">
            <div class="title_t" @click="onPage('index')">
                <img src="../../../assets/image/one/fanhui.png" alt="">
                <span>{{ $t('yi41') }}</span>
                <div></div>
            </div>
            <!-- <div class="title_x" @click="onPage('x')">
                <svg t="1732585927904" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="6277"
                    data-spm-anchor-id="a313x.search_index.0.i8.51fd3a819BMxuG" width="200" height="200">
                    <path
                        d="M512 128c211.2 0 384 172.8 384 384s-172.8 384-384 384-384-172.8-384-384 172.8-384 384-384m0-64C262.4 64 64 262.4 64 512s198.4 448 448 448 448-198.4 448-448-198.4-448-448-448z"
                        fill="#999999" p-id="6278" data-spm-anchor-id="a313x.search_index.0.i7.51fd3a819BMxuG"
                        class="selected"></path>
                    <path
                        d="M646.4 332.8L512 467.2 377.6 332.8c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8L467.2 512l-134.4 134.4c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l134.4 134.4c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l134.4-134.4c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z"
                        fill="#999999" p-id="6279" data-spm-anchor-id="a313x.search_index.0.i10.51fd3a819BMxuG"
                        class="selected"></path>
                </svg>
            </div> -->
        </div>

        <div class="goods">
            <div class="goods_box" v-for="el in list" :key="el.phase_sn">
                <div class="goods_box_tie">No. {{ el.phase_sn || '' }}</div>
                <div class="flex">
                    <div class="goods_box_le">
                        <img :src="el.goods_image || ''" alt="">
                    </div>
                    <div class="goods_box_ri">
                        <div> {{ el.goods_name || '' }}</div>
                        <span>{{ $t('yi20') }}<i>{{ el.usd || 0 }}USD</i></span>
                    </div>
                </div>
                <div class="goods_box_time">
                    {{ $t('yi42') }}{{ el.lottery_time || '' }}
                </div>

                <div class="goods_box_btn" v-if="el.exchange_type == 0">
                    <div @click="onExchange('pickup', el)">{{ $t('yi37') }}</div>
                    <div @click="onExchange('convert', el)">{{ $t('yi38') }}</div>
                </div>

                <div class="goods_box_cash" v-else>
                    {{ el.exchange_type == 2 ? $t('new8') : $t('new15') }}
                </div>

            </div>

            <div class="more" v-if="(page * limit) < Records.total" @click="more">{{ $t('yi21') }}</div>
        </div>
    </div>
</template>

<script>
import { WinGoodsList } from '../../../api/memberOne'
import { Dialog } from 'vant';
export default {
    props: {
        val: {
            default: '',
            type: String / Object
        },
    },
    data() {
        return {
            page: 1,
            limit: 10,
            Records: [],
            usd: 500,
            list: []
        }
    },
    created() {
        this.onBuyRecords()
    },
    mounted() {

    },
    methods: {
        onPage(v) {
            this.$emit('onPage', v)
        },
        onPagesWon(v,data,page){
            this.$emit('onPagesWon', v,data, page)
        },
        setUsd(v) {
            this.usd = v
            this.onBuyRecords()
        },
        more() {
            this.page++
            this.onBuyRecords()
        },
        onBuyRecords( v = 0) {
            if(v == 1){
                this.page = 1
                this.list = []
            }
            this.Records = []
            const { page, limit, val, usd } = this
            WinGoodsList({
                page: page,
                limit: limit,
            }, 'one').then(res => {
                if (res && res.result) {
                    this.Records = res.result
                    this.list.push(...res.result.data)
                }
            })
        },
        onExchange(type, v) {
            const title = type == 'pickup' ? this.$t('new16') : this.$t('new17')
            Dialog.confirm({
                message: title,
                confirmButtonText: this.$t('MessageBox.Confirm'),
                cancelButtonText: this.$t('MessageBox.Cancel'),
            }).then(() => {
                this.$emit('onPageData', type, v);
            }).catch(() => {})
        }
    }
}
</script>

<style scoped lang="scss">
.flex {
    display: flex;
}

.one_des {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
        // padding: 0 20px;
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 8px;
                height: 14px;
            }

            div {
                position: absolute;
                left: 0;
                bottom: -5px;
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }

        .title_x {
            cursor: pointer;
            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    .price {
        margin: 20px 0 10px;
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;

        .price_title {
            font-size: 16px;
            color: #333;
            font-weight: bold;
        }

        .price_body {
            padding: 20px 0 0;
            color: #EC3031;
            font-size: 12px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);


            div {
                margin-bottom: 20px;
            }

            span {
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }

    .goods::-webkit-scrollbar {
        display: none;
    }


    .goods {
        flex: 1;
        overflow-y: auto;
        margin: 20px 0 0;
        scrollbar-width: none;
        -ms-overflow-style: none;

        .goods_box {
            display: flex;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #F45C1D;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            display: flex;
            flex-direction: column;

            .goods_box_tie {
                color: #666666;
                font-size: 12px;
                margin-bottom: 10px;
            }

            .goods_box_le {
                border: 1px solid #F9A784;
                border-radius: 5px;
                img {
                    width: 100px;
                    height: 58px;
                    object-fit: contain;
                }

                display: flex;

                .goods_box_le_text {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;

                    div:nth-child(2) {
                        margin-bottom: 10px;
                    }

                    span {
                        color: #EA190F;
                        font-size: 12px;
                    }
                }
                font-size: 12px;
            }

            .goods_box_ri {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-size: 12px;
                margin-left: 10px;

                div {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    margin-bottom: 10px;
                    font-weight: bold;
                }
                span {
                    font-weight: bold;

                    i {
                        color: #EA190F;
                    }
                }
            }
        }

        .goods_box_time {
            font-size: 12px;
            color: #333;
            text-align: left;
            padding: 10px 0 5px;
            font-weight: bold;
        }

        .goods_box_btn {
            box-sizing: border-box;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;

            div {
                text-align: center;
                width: 100%;
                margin: 10px auto 0;
                background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                border-radius: 22px;
                color: #fff;
                font-size: 12px;
                padding: 10px 0;
            }
        }

        .goods_box_cash {
            text-align: right;
            font-size: 12px;
        }

        .more {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            text-align: center;
            height: 30px;
            border-radius: 20px;
            border: 1px solid #FE3421;
            font-size: 16px;
            box-sizing: border-box;
            color: #FE3421;
        }
    }
}
</style>